import { render, staticRenderFns } from "./BePromptUnauthorizedUser.vue?vue&type=template&id=584cb65f&scoped=true"
import script from "./BePromptUnauthorizedUser.vue?vue&type=script&lang=js"
export * from "./BePromptUnauthorizedUser.vue?vue&type=script&lang=js"
import style0 from "./BePromptUnauthorizedUser.vue?vue&type=style&index=0&id=584cb65f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584cb65f",
  null
  
)

export default component.exports